import React, { useState, useEffect } from 'react';
import {
  FaBars,
  FaTimes,
  FaLinkedin,
  FaGithub,
  FaWhatsapp,
  FaArrowDown,
} from 'react-icons/fa';
import { Typewriter } from 'react-simple-typewriter';
import './Header.css';

const navLinks = [
  { id: 'about', label: 'Sobre' },
  { id: 'technologies', label: 'Tecnologias' },
  { id: 'projects', label: 'Projetos' },
  { id: 'contact', label: 'Contato' },
];

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('');

  const toggleMenu = () => setIsOpen((v) => !v);
  const closeMenu = () => setIsOpen(false);

  // Detecta scroll e seção ativa
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);

      // Detecta qual seção está visível
      const sections = navLinks.map((l) => document.getElementById(l.id));
      const scrollPos = window.scrollY + window.innerHeight / 3;

      for (let i = sections.length - 1; i >= 0; i--) {
        const sec = sections[i];
        if (sec && sec.offsetTop <= scrollPos) {
          setActiveSection(navLinks[i].id);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Bloqueia scroll quando menu mobile está aberto
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  return (
    <>
      {/* Navbar topo (sempre visível) */}
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <a href="#hero" className="navbar-brand" onClick={closeMenu}>
          <span className="brand-mark">BN</span>
          <span className="brand-name">Bernardo Netto</span>
        </a>

        <ul className="navbar-links">
          {navLinks.map((link) => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                className={activeSection === link.id ? 'active' : ''}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <button
          className="menu-icon"
          onClick={toggleMenu}
          aria-label="Abrir menu"
          aria-expanded={isOpen}
        >
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
      </nav>

      {/* Hero */}
      <header id="hero" className="hero">
        <div className="hero-bg" aria-hidden="true">
          <div className="orb orb-1" />
          <div className="orb orb-2" />
        </div>

        <div className="hero-content">
          <span className="hero-greeting">👋 Olá, eu sou</span>

          <h1 className="hero-title">
            <Typewriter
              words={['Bernardo Netto']}
              cursor
              cursorStyle="_"
              typeSpeed={140}
              deleteSpeed={50}
              delaySpeed={1000}
            />
          </h1>

          <p className="hero-role">
            <Typewriter
              words={[
                'Fullstack Developer',
                'React Developer',
                'Java (Android) Developer',
                'IT Analyst',
                'Backend Developer',
                'Frontend Developer',
              ]}
              loop
              cursor
              cursorStyle="|"
              typeSpeed={80}
              deleteSpeed={30}
              delaySpeed={1500}
            />
          </p>

          <p className="hero-description">
            Construindo soluções web modernas com foco em performance,
            usabilidade e código limpo.
          </p>

          <div className="hero-actions">
            <a href="#projects" className="btn btn-primary">
              Ver Projetos
            </a>
            <a href="#contact" className="btn btn-outline">
              Fale Comigo
            </a>
          </div>

          <div className="hero-socials">
            <a
              href="https://www.linkedin.com/in/bernardo-netto/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://github.com/sl4k3r1"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="GitHub"
            >
              <FaGithub />
            </a>
            <a
              href="https://wa.me/5551995620737"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="WhatsApp"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>

        <a href="#about" className="scroll-down" aria-label="Rolar para baixo">
          <FaArrowDown />
        </a>
      </header>

      {/* Menu Mobile */}
      <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        <ul>
          {navLinks.map((link) => (
            <li key={link.id}>
              <a href={`#${link.id}`} onClick={closeMenu}>
                {link.label}
              </a>
            </li>
          ))}
        </ul>
      </div>

      <div
        className={`overlay ${isOpen ? 'active' : ''}`}
        onClick={closeMenu}
        aria-hidden="true"
      />
    </>
  );
};

export default Header;
